<script>
    import IfeSpotsPerYear from "./IfeSpotsPerYear.svelte";
    import { selectedField, selectedRegion, expandAll } from "../Stores";

    export let fieldCard;
    let isExpanded = false;

    function toggleExpand() {
        isExpanded = !isExpanded;
    }

    $: {
        isExpanded =
            fieldCard.field === $selectedField ||
            fieldCard.regions.has($selectedRegion) ||
            $expandAll;
    }
</script>

<div
    class="mt-10 p-3 outline outline-2 outline-neutral-100 rounded-md"
    cy_data="ife_card"
>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="mb-1" on:click={toggleExpand}>
        <h3
            class=" md:text-xl text-sm font-bold hover:font-extrabold cursor-pointer"
        >
            {fieldCard.field}
        </h3>
    </div>
    {#if isExpanded}
        {#each fieldCard.spots as spots_per_year}
            <IfeSpotsPerYear spots={spots_per_year} field={fieldCard.field} />
        {/each}
    {/if}
</div>
